import {
  Component,
  ContentChild,
  Host,
  Input,
  OnInit,
  TemplateRef,
} from '@angular/core';
import { PrCheckboxGroupComponent } from '../pr-checkbox-group.component';

@Component({
    selector: 'checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    standalone: false
})
export class CheckboxComponent implements OnInit {
  @ContentChild('optionTemplate', { static: true })
  optionTemplateRef: TemplateRef<any>;
  @Input() value: any;
  @Input() label: string = 'test';
  @Input() template: TemplateRef<any>;
  @Input() maxSelected = null;
  @Input() disabled = false;
  hash =
    Math.random().toString(36).substring(2, 15) +
    Math.random().toString(36).substring(2, 15);

  constructor(@Host() private checkboxGroup: PrCheckboxGroupComponent) {}
  ngOnInit(): void {}

  toggleCheck() {
    this.checkboxGroup.addOrRemove(this.value);
  }

  isChecked() {
    return this.checkboxGroup.contains(this.value) ? 'checked' : null;
  }
  isDisabled() {
    return this.checkboxGroup.model?.length >= this.maxSelected &&
      !this.checkboxGroup.contains(this.value)
      ? 'disabled'
      : null;
  }
  get formLabel() {
    return this.hash;
  }
}
